import { QueryOptions } from "../../Common/useQuery";
import useUserQuery from "../../Common/useUserQuery";
import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";

export enum PoCompletionType {
  Manual = 'Manual',
  Percentage = 'Percentage'
}

export interface PurchaseOrderSettingsDto {
  type: PoCompletionType;
  percentage?: number;
}

const useGetPurchaseOrderSettings = (options?: QueryOptions<PurchaseOrderSettingsDto>) => {
  const business = useSelectedBusiness();

  return useUserQuery<PurchaseOrderSettingsDto>(
    { path: `/api/businesses/${business.id}/purchaseOrderSettings` },
    options);
}

export default useGetPurchaseOrderSettings;
